module.exports = __webpack_public_path__ + "img/pullMsg.29c53eb0.png";